import { ANNOTATION_TYPE } from '@/shared/ui';

type PatternCtor = new (
  canvasChart: HTMLCanvasElement,
  config: any,
  displayedChannelsArr: number[],
  pixelSamples: any,
  pattern: { channelIndex: number; startSample: number; endSample: number },
) => any;

let PatternImpl: any;

(function () {
  PatternImpl = function (
    canvasChart: HTMLCanvasElement,
    config: any,
    displayedChannelsArr: number[],
    pixelSamples: any,
    pattern: { channelIndex: number; startSample: number; endSample: number },
  ) {
    this.type = ANNOTATION_TYPE.PATTERN;
    this.canvasChart = canvasChart;
    this.ctxChart = this.canvasChart.getContext('2d');
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
    this.pixelSamples = pixelSamples;
    this.channelIndex = pattern.channelIndex;
    this.startSample = pattern.startSample;
    this.endSample = pattern.endSample;
    this.color = 'blue';
  };

  PatternImpl.prototype.drawOnePattern = function (offsetX: number, strokeStyle = this.color) {
    this.ctxChart.beginPath();
    this.ctxChart.strokeStyle = strokeStyle;
    this.displayedChannelsArr.forEach((element: number, index: number) => {
      if (this.channelIndex === element) {
        for (let j = this.startSample; j < this.endSample; j += 1) {
          this.ctxChart.moveTo(
            this.pixelSamples[index][j].x - this.pixelSamples[index][offsetX].x,
            this.pixelSamples[index][j].y,
          );
          this.ctxChart.lineTo(
            this.pixelSamples[index][j + 1].x - this.pixelSamples[index][offsetX].x,
            this.pixelSamples[index][j + 1].y,
          );
        }
      }
      this.ctxChart.stroke();
      this.ctxChart.closePath();
    });
  };

  PatternImpl.prototype.update = function (
    pixelSamples: any,
    config: any,
    displayedChannelsArr: number[],
  ) {
    this.pixelSamples = pixelSamples;
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
  };

  PatternImpl.prototype.changeColor = function (color: string) {
    this.color = color;
  };

  PatternImpl.prototype.getJSONObject = function () {
    return {
      type: this.type,
      channelIndex: this.channelIndex,
      startSample: this.startSample,
      endSample: this.endSample,
      color: this.color,
    };
  };
})();

const Pattern: PatternCtor = PatternImpl;

export { Pattern };
export default { Pattern };
